import React from 'react';
import { Breadcrumbs } from 'components/Shared';
import contentBlockConfig from 'constants/contentBlockConfig';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const BreadcrumbsContainer = styled.div `
  margin-left: ${({ isMobile }) => (isMobile ? -12 : 0)}px;
`;
const ColoredIcon = styled.div `
  display: flex;
  align-items: center;

  path {
    fill: ${({ theme }) => theme.palette.primary.main};
  }
`;
const ContentBlockSingleBreadcrumb = ({ contentBlockName, isMobile = false, customTitle, }) => {
    var _a;
    const Icon = (_a = contentBlockConfig[contentBlockName]) === null || _a === void 0 ? void 0 : _a.icon;
    const theme = useTheme();
    const { t } = useTranslation();
    const breadcrumbs = [
        {
            title: customTitle || t(`content-blocks.${contentBlockName}`),
            Icon: Icon ? (React.createElement(ColoredIcon, { color: theme.palette.primary.main },
                React.createElement(Icon, null))) : null,
        },
    ];
    return (React.createElement(BreadcrumbsContainer, { isMobile: isMobile },
        React.createElement(Breadcrumbs, { config: breadcrumbs, mobile: isMobile })));
};
export default ContentBlockSingleBreadcrumb;
